import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
// Accept header for Laravel
axios.defaults.headers.common["Accept"] = "application/json";

// Request interceptor - Add token to every request
axios.interceptors.request.use(
  function (config) {
    const authUser = sessionStorage.getItem("authUser");
    if (authUser) {
      try {
        const { token } = JSON.parse(authUser);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error("Error parsing auth user:", error);
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors and token expiration
axios.interceptors.response.use(
  function (response) {
    // Handle 204 No Content - return empty object to prevent errors
    if (response.status === 204) {
      return {};
    }
    return response.data ? response.data : response;
  },
  function (error) {
    // Handle 401 - Unauthorized (token expired or invalid)
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      sessionStorage.removeItem("authUser");

      // Only redirect to login if not already on a public route
      if (currentPath !== "/login" &&
        currentPath !== "/logout" &&
        currentPath !== "/register" &&
        currentPath !== "/forgot-password") {
        window.location.href = "/login";
      }
    }

    // Extract error message
    let message;
    if (error.response?.data?.message) {
      message = error.response.data.message;
    } else if (error.response?.status) {
      switch (error.response.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        case 403:
          message = "Access Forbidden";
          break;
        default:
          message = error.message || error;
      }
    } else {
      message = error.message || error;
    }

    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };

  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };